import { render, staticRenderFns } from "./businessIndex.vue?vue&type=template&id=bf3ad88c&scoped=true&"
import script from "./businessIndex.vue?vue&type=script&lang=js&"
export * from "./businessIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3ad88c",
  null
  
)

export default component.exports